import config from 'config'
import { useMutation } from 'hooks'
import { useEffect, useMemo, useState } from 'react'


// TODO add &s=1 for suggestions
const useCoordsByAddress = (address: string, skip: boolean) => {
  const { cityName } = config

  const [ data, setData ] = useState<[ number, number ]>()

  const [ submit, { isSubmitting } ] = useMutation<{ lat: string, lng: string }>({
    url: '/mob_ajax.php?action=geosearch',
  })

  const formattedAddress = useMemo(() => address.trim(), [ address ])

  useEffect(() => {
    if (skip || !formattedAddress || !cityName) {
      return
    }

    const body = {
      address: formattedAddress.includes(cityName)
        ? formattedAddress
        : `${formattedAddress}, ${cityName}`,
    }

    submit(body)
      .then(({ data }) => {
        if (data?.lat && data?.lng) {
          setData([ Number(data.lat), Number(data.lng) ])
        }
      })
  }, [ formattedAddress, cityName, skip, submit ])

  return {
    coords: data,
    isCoordsFetching: isSubmitting,
  }
}


export default useCoordsByAddress
